<template>
  <div v-if="config">
    <sweet-modal ref="config" class="s-checkout" @close="close">
      <template slot="title">
        <div class="d-flex justify-content-between align-items-center" style="width: 100%;">
          <h4>Supercheckout</h4>
          <button type="button" class="btn btn-outline-secondary btn-small d-flex align-items-center"
                  @click="openSuperCheckout">
            <i class="svg-icon svgi-checkout svgi-lg "/>
            {{ $t('ct-supercheckout') }}
          </button>
        </div>
      </template>
      <div class="d-flex">
        <button type="button" class="btn btn-outline-info btn-small"
                v-if="auth && auth.business_info && action === 'select'"
                @click="action = 'form'"
        >{{ $t('ct-checkout-create-product') }}
        </button>
        <h4 v-if="action === 'business-info'">{{ $t('ct-checkout-business-info') }}</h4>
      </div>
      <div v-if="!loading.auth && error">
        {{ error }}
      </div>
      <div v-if="loading.auth && !error">
        {{ $t('ct-loading') }}
      </div>
      <template v-if="!loading.auth && !error">
        <div v-if="loading.products">
          {{ $t('ct-loading-products') }}
        </div>
        <div v-else>
          <checkout-business-info
            v-if="auth && action === 'business-info'"
            :auth="auth"
            v-model="auth.business_info"
            @input="action = 'form'"
          />
          <div class="mt-4" v-if="action === 'select' && !config.sellableHash">
            <h4>{{ $t('ct-checkout-select-product') }}</h4>
            <p class="col-xs-12 col-sm-8 pl-1">
              {{ $t('ct-checkout-select-product-info') }}
            </p>
            <div v-for="product in products" :key="product.hash">
              <h5 class="pl-1 mt-3">{{ product.name }} </h5>
              <template v-if="product.versions[0].payment_type === 1">
                <!-- sale-->
                <button class="btn btn-primary btn-sm"
                        @click="select('product-versions', product.versions[0].hash, product.versions[0].language)"
                >
                  Product: {{ product.name }}
                  {{ product.versions[0].currency }}
                  {{ product.versions[0].total / 100 }}
                </button>
              </template>
              <template v-if="product.versions[0].payment_type === 2">
                <!-- plans-->
                <button class="btn btn-primary btn-sm"
                        v-for="plan in product.versions[0].plans"
                        :key="plan.hash"
                        @click="select('plans', plan.hash, product.versions[0].language)"
                >Plan: {{ plan.name }} {{ plan.currency }} {{ plan.price / 100 }}
                </button>
              </template>
              <button class="btn btn-primary btn-sm"
                      v-if="product.offers"
                      v-for="(name, hash) in product.offers"
                      :key="hash"
                      @click="select('offers', hash, product.versions[0].language)"
              >Offer {{ name }}
              </button>
              <button class="float-right btn btn-outline-info" @click="editProduct(product)">{{
                  $t('ct-edit')
                }}
              </button>
            </div>
          </div>

          <form-config v-if="config && action === 'select' && config.sellableHash" :config="config" @done="done"/>

          <checkout-product-form
            ref="form"
            v-if="auth && action === 'form'"
            :auth="auth"
            :config="config"
            @done="formDone"
          />
        </div>
      </template>
    </sweet-modal>
  </div>
</template>

<script>
import {SweetModal, SweetModalTab} from 'sweet-modal-vue';
import TextEditor from '../../base/TextEditor';
import TextAreaComponent from '../../resources/TextArea';
import {auth, getProducts, apiUrl} from '../../../../js/services/integrations-internas/supercheckout';
import CheckoutBusinessInfo from './Form/CheckoutBusinessInfo';
import CheckoutProductForm from './Form/CheckoutProductForm';
import FormConfig from './Form/FormConfig';
import {get as getWebsite} from '../../../../js/services/editor/website';

export default {
  name: 'ConfigModal',

  components: {
    TextAreaComponent,
    TextEditor,
    SweetModal,
    SweetModalTab,
    CheckoutBusinessInfo,
    CheckoutProductForm,
    FormConfig
  },

  data() {
    return {
      action: 'select',
      config: null,
      options: {
        pages: []
      },
      callback: null,
      element: null,
      auth: null,
      products: [],
      loading: {
        auth: true,
        products: true,
        business: true
      },
      error: null,
      lang: 'en_US'
    };
  },

  methods: {
    formDone(products) {
      if (products)
        this.products = products;

      this.action = 'select';
    },

    openSuperCheckout() {
      auth(this.$parent.$data.id_website, this.lang).then(async({data}) => {
        if (data.token) {
          let token = data.token;
          localStorage.setItem('token_supercheckout', token);
          this.auth.token = token;

          return window.open(`${apiUrl()}?token=${this.auth.token}`);
        }
      })
    },

    editProduct(product) {
      this.action = 'form';
      this.$nextTick(() => this.$refs.form.editProduct(product));
    },

    init(config, callback = false, element) {
      getWebsite(this.$parent.$data.id_website).then((websiteObj) => {
        this.lang = websiteObj.data.language
        auth(this.$parent.$data.id_website, this.lang).then(async({data}) => {
          if (data.token) {
            this.auth = data;
            if (!data.business_info) {
              this.action = 'business-info';
              this.auth.business_info = {
                business_name: data.layout.title,
                contact_email: data.layout.user.email
              };
            }

            await getProducts(this.auth.token).then(({data}) => {
              this.products = data.products;
              this.loading.products = false;
            });
          } else
            this.error = this.$t('ct-checkout-erro-retrieving-token');

          this.loading.auth = false;
        });
      });
      this.config = config;
      this.callback = callback;
      this.element = element;
    },

    open() {
      this.$refs.config.open();
    },

    select(type, hash, language) {
      this.config.type = type;
      this.config.sellableHash = hash;
      this.$set(this.config, 'texts', {
        baloon: this.config.texts.baloon || this.$t('ct-baloon-text'),
        step1_title: this.config.texts.step1_title || this.$t('ct-checkout-shipping'),
        step1_text: this.config.texts.step1_text || this.$t('ct-checkout-where-to'),
        step2_title: this.config.texts.step2_title || this.$t('ct-checkout-your-info'),
        step2_text: this.config.texts.step2_text || this.$t('ct-checkout-pay-it'),
        buy_button: this.config.texts.buy_button || this.$t('ct-checkout-buy-button-text'),
        pay_button: this.config.texts.pay_button || this.$t('ct-checkout-pay-button-text'),
        buy_button_sub: this.config.texts.buy_button_sub || this.$t('ct-checkout-buy-button-subtext'),
        bottom_info: this.config.texts.bottom_info || this.$t('ct-checkout-bottom-info-text'),
        continue_button: this.config.texts.continue_button || this.$t('ct-checkout-continue-button'),
        security_title: this.config.texts.security_title || this.$t('ct-checkout-security-title'),
        security_text: this.config.texts.security_text || this.$t('ct-checkout-security-content'),
        payment_button: this.config.texts.payment_button || this.$t('ct-checkout-payment-button'),
        thank_you_title: this.config.texts.thank_you_title || this.$t('ct-checkout-thankyou-title'),
        thank_you_text: this.config.texts.thank_you_text || this.$t('ct-checkout-thankyou-text'),
        get_product_button: this.config.texts.get_product_button || this.$t('ct-checkout-thankyou-get-product-button')
      });
      this.config.language = language;
    },
    done() {
      this.callback(this.config);
      this.$refs.config.close();
    },
    close() {
      this.action = 'select';
      this.callback(this.config);
      $(this.element).detach();
    }
  }
};
</script>
<style>
.s-checkout .sweet-modal .sweet-content {
  display : block !important;
}

.s-checkout .sweet-modal .sweet-title {
  height : auto !important;
}

.s-checkout .gear-icon {
  height : 20px;
}
</style>
<style scoped>
>>> ul {
  margin-left   : 0 !important;
  padding-left  : 1rem !important;
  margin-bottom : 1rem !important;
}

>>> .btn {
  margin-left : 0;
}

>>> .btn + .btn {
  margin-left : 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/ConfigModal.vue